// Lightweight shared keyboard navigation; no account or cart mutation.
const campaignKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
const incoming = new URLSearchParams(location.search);
function decorateCampaignLink(link) {
  const target = new URL(link.href, location.origin);
  if (target.origin !== location.origin || !/^\/(products|collections|pages)\//.test(target.pathname)) return;
  campaignKeys.forEach(key => {
    const value = incoming.get(key);
    if (value && value.length <= 180 && !target.searchParams.has(key)) target.searchParams.set(key,value);
  });
  link.href = target.pathname + target.search + target.hash;
}
document.querySelectorAll('a[href]').forEach(decorateCampaignLink);
// Shopify can replace the header after localization/cart updates. Delegate so
// replacement links and disclosure controls keep their behavior.
document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (link) decorateCampaignLink(link);
  document.querySelectorAll('[data-sr-bold-menu][open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
}, true);
document.addEventListener('keydown', event => {
  const menu = event.target.closest('[data-sr-bold-menu]');
  if (!menu || event.key !== 'Escape') return;
  event.preventDefault();
  menu.open = false;
  menu.querySelector('summary').focus();
});
document.querySelectorAll('[data-sr-editorial-media]').forEach(root => {
  const gallery = root.querySelector('.sr-editorial-gallery');
  const move = direction => gallery.scrollBy({left: direction * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  root.querySelector('[data-sr-gallery-prev]')?.addEventListener('click', () => move(-1));
  root.querySelector('[data-sr-gallery-next]')?.addEventListener('click', () => move(1));
  gallery.addEventListener('keydown', event => {
    if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
  });
});
